import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { apiName } from "./data.service";

@Injectable()
export class ManutencaoProgramadaApiService {

    constructor(
        private _restService: RestService
    ) { }

    onGetAll(done: any) {
        this._restService.onGet(apiName + '/alarmes', done);
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/manutencao-programada/shared/manutencao-programada-api.service.ts
 **/